<template>
    <div class="editForm">
        <div class='top'>
            <div class="edit-tab">
                <el-radio-group v-model="tab" class="edit-tab" v-bind="$attrs" v-on="$listeners">
                    <el-radio-button v-for="(title,key) in titles" :key="key" :label="key+1">{{title}}</el-radio-button>
                </el-radio-group>
            </div>
            <div class="save-button">
                <slot class="save-button" name="save"/>
            </div>
        </div>
        <div class="edit">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
	data(){
		return {
			tab:1,
		}
	},
	props:{
		titles:{
			type:Array,
			default(){return []}
		},
		value:{
			type:Number,
			default(){return 1}
		}
	}
}
</script>

<style scoped>
.editForm{
    width:100%;
    height: 100%;
    display:flex;
    flex-direction: column;
}
.top {
    display: flex;
    flex-direction: row;
    z-index: 10;
    margin-bottom: 30px; 
    flex-wrap: wrap-reverse;
}
.edit-tab {
    margin-bottom: 20px;
}
.save-button {
    margin-left:100px;
}
.edit {
    width: 100%;
    flex-grow: 10;
    overflow: scroll;
}
</style>
